import { motion } from 'framer-motion';
import { Brain, Globe, Plug, Users, Zap, Shield } from 'lucide-react';
import { useLang } from '../../../context/LangContext';
import { GlassCard } from '../../shared/GlassCard';
import { staggerContainer, staggerChild } from '../../../animations/variants';

const features = [
  { icon: Brain, titleKey: "features.1.title", descKey: "features.1.desc" },
  { icon: Globe, titleKey: "features.2.title", descKey: "features.2.desc" },
  { icon: Plug, titleKey: "features.3.title", descKey: "features.3.desc" },
  { icon: Users, titleKey: "features.4.title", descKey: "features.4.desc" },
  { icon: Zap, titleKey: "features.5.title", descKey: "features.5.desc" },
  { icon: Shield, titleKey: "features.6.title", descKey: "features.6.desc" },
];

export const Features = () => {
  const { t } = useLang();

  return (
    <section id="features" data-testid="features-section" className="relative py-24 md:py-32 bg-[#020209]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 55, damping: 18 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
            {t("features.title")}
          </h2>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
        >
          {features.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <motion.div key={i} variants={staggerChild}>
                <GlassCard className="p-6 h-full" data-testid={`feature-card-${i}`}>
                  <Icon size={28} className="text-brand-green mb-4" strokeWidth={1.5} />
                  <h3 className="text-lg font-semibold text-white mb-2">{t(feature.titleKey)}</h3>
                  <p className="text-sm text-neutral-400 leading-relaxed">{t(feature.descKey)}</p>
                </GlassCard>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
